module.exports = __webpack_public_path__ + "servershield.svg?0eb8d6d70d4e74cab464a40e9c6360eb";